export default __webpack_public_path__ + "static/media/covi19.83c757b9.jpeg";